/// 一覧フィルタの選択肢に「候補に無いが選択済み」の値を補うヘルパー (FSD: features)。
///
/// 復元した保存値の中には、 現在の候補 API (先頭 N 件 / active のみ 等) や
/// マスタに存在しない値が含まれうる。 そのままだとチェックボックスが描画されず
/// ユーザーが個別に解除できないため、 選択済みの未知値を「不明な項目」として
/// options に補い、 解除可能にする。 表示ラベルのポリシーを持つため features に置く。

import type { SimpleOption } from '@shared/constants/choices';

/**
 * `selectedValues` のうち `options` に無い値を末尾に追記する。
 *
 * `formatUnknownLabel` 未指定時は `formatUnknownOptionLabel`
 * (`不明な項目 (…abbreviated)`) を使う。 役職など名称そのものが意味を持つフィルタでは
 * `(value) => value` を、 別リストで実名解決できるフィルタでは解決関数を渡す。
 */
export function withUnknownSelectedOptions(
  options: SimpleOption[],
  selectedValues: string[] | undefined,
  formatUnknownLabel: (value: string) => string = formatUnknownOptionLabel,
): SimpleOption[] {
  if (!selectedValues?.length) return options;
  const known = new Set(options.map((option) => option.value));
  const unknown = selectedValues
    .filter((value) => !known.has(value))
    .map((value) => ({
      value,
      label: formatUnknownLabel(value),
    }));
  return unknown.length > 0 ? [...options, ...unknown] : options;
}

/** 候補にも実名リストにも無い未知値の既定ラベル (`不明な項目 (…abbreviated)`)。 */
export function formatUnknownOptionLabel(value: string): string {
  return `不明な項目 (${abbreviate(value)})`;
}

function abbreviate(value: string): string {
  return value.length > 12 ? `${value.slice(0, 8)}…` : value;
}
